import React, { Fragment, useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';
import ReactLoading from 'react-loading';

import Header from 'components/Header';
import Footer from 'components/Footer';

import {
  checkPreviousAction,
} from 'actions/workflow';

import style from './style.scss';

const DirectAccess = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const workflow = useSelector((state) => state.workflow);

  useEffect(() => {
    const key = searchParams.get('key');
    if (!key) {
      navigate('/');
    } else {
      dispatch(checkPreviousAction({
        data: {},
        url: `/workflows/${params.workflowType}/${key}/step/${params.stepName}`,
        fail: (error) => {
          if (get(error, 'data.message')) {
            navigate(`/fsl/error?key=${key}`, {
              state: { message: get(error, 'data.message') },
            });
          } else if (get(error, 'data.failure.errors.0')) {
            navigate(`/fsl/error?key=${key}`, {
              state: { message: get(error, 'data.failure.errors.0.message') },
            });
          } else {
            navigate(`/fsl/error?key=${key}`, {
              state: { message: 'Sorry, an error occurred' },
            });
          }
        },
      }));
    }
  }, []);

  const data = get(workflow, 'data');
  if (data) {
    const routeUrl = data.url;
    navigate(routeUrl);
  }

  return (
    <Fragment>
      <Header />
      <div className={style.container}>
        <div className={style.loading}><ReactLoading color="#04bc6c" width={100} height={100} /></div>
      </div>
      <Footer />
    </Fragment>
  );
};

export default DirectAccess;
